module.exports = __webpack_public_path__ + "static/media/comment-alt-medical.771e9116.svg";